var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentLocation48Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2562 12.075C16.8015 11.0517 17.0856 9.90953 17.0833 8.75C17.0833 4.83792 13.9121 1.66667 10 1.66667C6.08792 1.66667 2.91667 4.83792 2.91667 8.75C2.91373 10.421 3.50439 12.0386 4.58333 13.3146L4.59167 13.325L4.59917 13.3333H4.58333L8.78667 17.7958C8.94248 17.9612 9.13048 18.093 9.3391 18.1831C9.54772 18.2732 9.77256 18.3196 9.99979 18.3196C10.227 18.3196 10.4519 18.2732 10.6605 18.1831C10.8691 18.093 11.0571 17.9612 11.2129 17.7958L15.4167 13.3333H15.4008L15.4075 13.3254L15.4083 13.3246C15.4383 13.2888 15.4682 13.2526 15.4979 13.2162C15.787 12.8611 16.041 12.4792 16.2562 12.075ZM10.0021 11.4579C9.33904 11.4579 8.70316 11.1945 8.23432 10.7257C7.76548 10.2568 7.50208 9.62096 7.50208 8.95792C7.50208 8.29488 7.76548 7.65899 8.23432 7.19015C8.70316 6.72131 9.33904 6.45792 10.0021 6.45792C10.6651 6.45792 11.301 6.72131 11.7699 7.19015C12.2387 7.65899 12.5021 8.29488 12.5021 8.95792C12.5021 9.62096 12.2387 10.2568 11.7699 10.7257C11.301 11.1945 10.6651 11.4579 10.0021 11.4579Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentLocation48Filled);
export default __webpack_public_path__ + "static/media/fluent_location-48-filled.1566352816d9721a4040318192599936.svg";
export { ForwardRef as ReactComponent };